import { DefaultService } from '@/services/DefaultService';

export default class GradeService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/sales/grid.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	updateSituacao(grade) {
		return this._http.post(`${this._env}/sales/grid/updatesituacao`, grade, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	find(id) {
		return this._http.get(`${this._env}/sales/grid/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findByIdProduto(idgrade, idproduto) {
		return this._http.get(`${this._env}/sales/gridproduct.json?idproduto=${idproduto}&idgrade=${idgrade}`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	save(form) {
		return this._http.post(`${this._env}/sales/grid`, form, this._headers).then(res => {
			return res.body;
		}, err => {
				handleError(err);
			});
		}

    getAllColunas(...searchColuna) {
        return this._http.get(`${this._env}/sales/grid/columns.json?searchColuna=${searchColuna}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getAllLinhas(...searchLinha) {
        return this._http.get(`${this._env}/sales/grid/lines.json?searchLinha=${searchLinha}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}